import type { Breakpoint } from "antd/es/_util/responsiveObserver";

interface ResponsiveColumn {
  responsive: Breakpoint[];
}

export const FROM_TABLET_COLUMN: ResponsiveColumn = { responsive: ["md"] };
export const FROM_LAPTOP_COLUMN: ResponsiveColumn = { responsive: ["lg"] };
export const FROM_DESKTOP_COLUMN: ResponsiveColumn = { responsive: ["xl"] };
